/**
 * Configuration information for the audience group for OCV telemetry
 */ export var AudienceGroup = /*#__PURE__*/ function(AudienceGroup) {
    AudienceGroup["Automation"] = "Automation";
    AudienceGroup["Dogfood"] = "Dogfood";
    AudienceGroup["Microsoft"] = "Microsoft";
    AudienceGroup["Insiders"] = "Insiders";
    AudienceGroup["Production"] = "Production";
    return AudienceGroup;
}({});
/** Log tracing verbosity level */ export var TraceLevel = /*#__PURE__*/ function(TraceLevel) {
    /** Critical non recoverable error */ TraceLevel[TraceLevel["Error"] = 0] = "Error";
    /** Non critical error */ TraceLevel[TraceLevel["Warning"] = 1] = "Warning";
    /** Informational and default diagnostic level */ TraceLevel[TraceLevel["Info"] = 2] = "Info";
    /** Fine grained verbose logs for detailed debugging */ TraceLevel[TraceLevel["Verbose"] = 3] = "Verbose";
    return TraceLevel;
}({});
/** Id of the window property containing settings for the app */ export const SettingsObjectName = "planner";
